import { emptySplitApi } from "./empty-split-api";

export interface ICD10Code {
  id: number;
  code: string;
  description: string;
}

type ICD10CodesResponse = ICD10Code[];

const extendedIcdCodesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getICD10Codes: builder.query<
      ICD10CodesResponse,
      { search?: string; is_active?: boolean }
    >({
      query: (params) => ({
        url: `icd10-codes/`,
        params: {
          limit: 300,
          ...params,
          search: params.search ? encodeURIComponent(params.search) : undefined
        }
      }),
      providesTags: ["ICD10Codes"]
    }),
    autoCompleteICD10Codes: builder.mutation<string, { chart_note_id: number }>(
      {
        query: (chartNoteData) => ({
          url: "icd10-codes/complete",
          method: "POST",
          body: chartNoteData
        })
      }
    )
  })
});

export const { useGetICD10CodesQuery, useAutoCompleteICD10CodesMutation } =
  extendedIcdCodesApi;
